module.exports = __webpack_public_path__ + "img/cv.4e54347b.svg";